import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import {
  deleteReligionMaster,
  enableDisableReligionMaster,
  getDetailsReligionMaster,
} from "../../../../Apis/ReligionMasterApi/ReligionMasterApi";
import ReligionContext from "../../../../context/ReligionContext/ReligionContext";
import Actions from "../../../../layouts/Actions";

const ReligionDataTabelContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setdialogs,
    setOrgId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(ReligionContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get Religion Details
   */
  const { mutate: ReligionDetails_, isLoading: isLoadingReligionDetails } =
    useMutation((religionId) =>
      getDetailsReligionMaster(religionId, setFormData, setdialogs)
    );

  const ReligionDetails = (religionId) => {
    ReligionDetails_(religionId);
    setOrgId(religionId);
    setIsEdit(false);
  };

  /**
   * delete Religion
   */
  const { mutate: ReligionDelete, isLoading: isLoadingDelete } = useMutation(
    (religionId) => deleteReligionMaster(religionId, refetch)
  );

  const DeleteReligion = async (religionId) => {
    SweetConfirmation(ReligionDelete, religionId);
  };

  /**
   * enable / disable Religion
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    enableDisableReligionMaster(formData, refetch)
  );

  const handleReligionStatusChange = (religionId, status) => {
    let formDate = {
      religionId: religionId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.religionId === religionId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 180,
      field: "name",
      headerName: "Name",
      renderCell: (params) => (params.row.name ? params.row.name : "--"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleReligionStatusChange(
                params.row.religionId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <Actions
            id={params.row.religionId}
            getDetails={ReligionDetails}
            deleteDetails={DeleteReligion}
          />
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingReligionDetails || isLoadingDelete}
      />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.religionId}
        addButton={true}
      />
    </Fragment>
  );
};

export default ReligionDataTabelContainer;
